import { Injectable } from '@angular/core';
import { Api } from '../api.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import LogRocket from 'logrocket';

export interface StewartAuthVerifierState {
	code_verifier: string;
	state: string;
}

@UntilDestroy()
@Injectable({
	providedIn: 'root',
})
export class StewartTokensApiService extends Api {
	code: string;
	state: string;
	constructor(
		private httpClient: HttpClient,
		private route: ActivatedRoute,
	) {
		super(httpClient);
		this.route.queryParams.pipe(untilDestroyed(this)).subscribe((params) => {
			this.code = params['code'];
			this.state = params['state'];
		});
	}

	public async getTokensFromCodeExchange() {
		const verifierState: StewartAuthVerifierState = JSON.parse(
			localStorage.getItem('stewart-title-verifier-state'),
		);
		const { code_verifier: codeVerifier, state: storedState } = verifierState;

		if (this.code && codeVerifier && storedState === this.state) {
			LogRocket.info(
				`${StewartTokensApiService.name}.${this.getTokensFromCodeExchange.name}: Exchanging code for token.`,
			);

			const exchange = await this.exchangeCodeForToken(
				this.code,
				codeVerifier,
				this.state,
			).toPromise();

			if (exchange.access_token) {
				localStorage.removeItem('stewart-title-verifier-state');
				return true;
			} else {
				return false;
			}
		} else {
			localStorage.removeItem('stewart-title-verifier-state');
			return false;
		}
	}

	exchangeCodeForToken(
		code: string,
		codeVerifier: string,
		state: string,
	): Observable<{ access_token: string }> {
		const body = {
			code,
			codeVerifier,
			state,
		};

		const url = `${environment.api.baseUrl}/closer/stewartTitle/token`;
		const response = this.httpClient
			.post(url, body, { responseType: 'text' })
			.pipe(
				map((response: string) => {
					return {
						access_token: response,
					};
				}),
			);
		return response;
	}
}
